import { configureStore } from '@reduxjs/toolkit';
import { getCoreOptions } from '../foundation/coreOptions';
import { scenarioSlice } from './features/scenario.slice';
import { pageTransitionEnhancer, pageTransitionMiddleware } from './pageTransition';
import { exposeStoreForPerf, initPerfState, perfMiddleware } from './perf';

initPerfState();

// Page transitions (`uiEffects`) hook into the store only for a package that turns them on in its core-options.json
// (consumer); every other app keeps the store exactly as before.
const pageTransitions = getCoreOptions().animation?.pageTransitions === true;

export const store = configureStore({
    reducer: {
        [scenarioSlice.name]: scenarioSlice.reducer,
    },
    devTools: process.env.NODE_ENV !== 'production',
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(...(pageTransitions ? [pageTransitionMiddleware] : []), perfMiddleware),
    enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(...(pageTransitions ? [pageTransitionEnhancer] : [])),
});

exposeStoreForPerf(store);
